import type { UserAgreement } from '~/composables/UserAgreement'
import type { UserAgreementType } from '~/composables/UserAgreementType'
import type { LegalAgreementPage } from '~/services/api/generated'

export const isUserAgreementOfType =
  (type: UserAgreementType) =>
  (agreement: LegalAgreementPage['agreements'][number]): agreement is UserAgreement =>
    agreement.type === type
